export const navLinks = [
  { label: "今日更新", href: "#today" },
  { label: "每日推荐", href: "#picks" },
  { label: "实时热榜", href: "#hot" },
  { label: "最新发布", href: "#latest" },
  { label: "话题墙", href: "#topics" },
  { label: "专题合集", href: "#collections" },
];

export const entryChips = [
  { label: "今日更新", icon: "ri-flashlight-fill", href: "#today" },
  { label: "每日推荐", icon: "ri-star-fill", href: "#picks" },
  { label: "实时热榜", icon: "ri-fire-fill", href: "#hot" },
  { label: "最新发布", icon: "ri-time-fill", href: "#latest" },
  { label: "新鲜出炉", icon: "ri-bard-fill", href: "#ticker" },
  { label: "话题墙", icon: "ri-hashtag", href: "#topics" },
];

export const keywordTags = [
  "综艺速递",
  "剧集路透",
  "榜单盘点",
  "网友热议",
  "红毯现场",
  "新歌首发",
];

export const tickerItems = [
  "《周末开麦》收官夜彩排路透流出，舞台设计引发弹幕热议",
  "某都市情感剧官宣第二季阵容，网友评论区已开始站队",
  "音乐平台新歌榜周冠易主，实时更新数据持续走高",
  "跨年盛典嘉宾名单新鲜出炉，主打「回忆杀」主题",
  "综艺《慢生活日志》取景地曝光，民宿预订量肉眼可见上涨",
  "顶流舞台合作舞台预告片今日更新，播放量一小时破百万",
  "年度剧集金榜入围名单每日推荐，票选通道今晚开启",
  "时装周看秀造型图鉴新鲜出炉，红毯造型师开启二选一投票",
];

export const todayCategories = ["全部", "综艺", "剧集", "明星动态", "热点", "榜单"];

export type TodayItem = {
  id: number;
  category: string;
  title: string;
  excerpt: string;
  tag: string;
  heat: string;
  time: string;
  isTop: boolean;
};

export const todayFeed: TodayItem[] = [
  {
    id: 1,
    category: "综艺",
    title: "《周末开麦》收官舞台完成联排，主打曲目名单流出",
    excerpt: "节目组深夜发出收官预告，现场观众晒出歌单与舞美图，讨论度一路走高。",
    tag: "综艺速递",
    heat: "86.2万",
    time: "10 分钟前",
    isTop: true,
  },
  {
    id: 2,
    category: "剧集",
    title: "古装剧《长风引》今晚加更两集，原著粉在线催更",
    excerpt: "官方发布加更海报并放出下集看点，弹幕区已提前「排班」。",
    tag: "剧集路透",
    heat: "54.7万",
    time: "26 分钟前",
    isTop: false,
  },
  {
    id: 3,
    category: "明星动态",
    title: "年度音乐盛典红毯生图陆续流出，造型师开启线上打分",
    excerpt: "多组高清生图在社交平台传播，各家粉丝纷纷加入审美对垒。",
    tag: "红毯现场",
    heat: "41.3万",
    time: "48 分钟前",
    isTop: false,
  },
  {
    id: 4,
    category: "热点",
    title: "「二搭愿望清单」话题冲上热搜，评论区呼声最高的组合出炉",
    excerpt: "剧集售后互动带热话题，观众开始自发投票期待二次合作。",
    tag: "网友热议",
    heat: "73.1万",
    time: "1 小时前",
    isTop: false,
  },
  {
    id: 5,
    category: "榜单",
    title: "短视频平台本周涨粉黑马盘点，新生代创作者集体破圈",
    excerpt: "多位素人创作者凭借创意内容单周涨粉超百万，榜单实时更新。",
    tag: "榜单盘点",
    heat: "32.8万",
    time: "2 小时前",
    isTop: false,
  },
  {
    id: 6,
    category: "综艺",
    title: "观察类综艺《家有来电》发布先导预告，观察室阵容引期待",
    excerpt: "先导片透露全新规则，观众对嘉宾互动模式充满好奇。",
    tag: "综艺速递",
    heat: "28.4万",
    time: "3 小时前",
    isTop: false,
  },
  {
    id: 7,
    category: "剧集",
    title: "都市剧《第九号天台》杀青，主创晒出片场合影",
    excerpt: "杀青照配文感人，评论区纷纷留言期待早日定档播出。",
    tag: "剧集路透",
    heat: "25.9万",
    time: "5 小时前",
    isTop: false,
  },
  {
    id: 8,
    category: "明星动态",
    title: "歌坛新单上线一小时空降热播榜，风格转变成讨论焦点",
    excerpt: "新曲尝试全新曲风，专业乐评人与乐迷评价两极但热度不减。",
    tag: "新歌首发",
    heat: "61.5万",
    time: "7 小时前",
    isTop: false,
  },
];

export type RankItem = {
  rank: number;
  title: string;
  category: string;
  heat: number;
  delta: string;
  trend: "up" | "down" | "flat" | "new";
};

export const hotRank: RankItem[] = [
  { rank: 1, title: "跨年盛典首波官宣阵容，观众开始「拼单看台」", category: "综艺", heat: 986, delta: "持续走高", trend: "up" },
  { rank: 2, title: "都市剧《第九号天台》杀青照霸屏热搜榜", category: "剧集", heat: 924, delta: "上升 3 位", trend: "up" },
  { rank: 3, title: "音乐盛典红毯造型生图大赏现场开评", category: "榜单", heat: 873, delta: "新上榜", trend: "new" },
  { rank: 4, title: "「二搭愿望清单」评论区票选进入白热化", category: "热点", heat: 815, delta: "持平", trend: "flat" },
  { rank: 5, title: "观察类综艺《家有来电》先导片释出", category: "综艺", heat: 762, delta: "下降 2 位", trend: "down" },
  { rank: 6, title: "新单《夜航星》空降热播榜前三，风格转型受关注", category: "明星动态", heat: 708, delta: "上升 1 位", trend: "up" },
  { rank: 7, title: "古装剧《长风引》今晚加更，站内热度破 9000", category: "剧集", heat: 654, delta: "持平", trend: "flat" },
  { rank: 8, title: "短视频涨粉黑马盘点，素人创作者集体破圈", category: "榜单", heat: 598, delta: "上升 5 位", trend: "up" },
  { rank: 9, title: "年度剧集金榜票选通道开启，首日投票破两百万", category: "热点", heat: 541, delta: "下降 1 位", trend: "down" },
  { rank: 10, title: "《周末开麦》收官夜联排路透引发弹幕狂欢", category: "综艺", heat: 486, delta: "新上榜", trend: "new" },
];

export type PickItem = {
  id: number;
  title: string;
  sub: string;
  desc: string;
  tag: string;
  date: string;
  read: string;
  img: string;
};

export const dailyPicks: PickItem[] = [
  {
    id: 1,
    title: "年度综艺「出圈时刻」合集",
    sub: "看完还想再看",
    desc: "把今年播放量最高的舞台高光、爆梗瞬间与嘉宾名场面整理成一份可反复刷的收藏，追更不迷路。",
    tag: "综艺速递",
    date: "每日推荐 · 今日",
    read: "68 万围观",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20vibrant%20concert%20stage%20with%20spotlights%20and%20confetti%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20cinematic%20composition&width=800&height=600&seq=chigua-pick-01&orientation=landscape",
  },
  {
    id: 2,
    title: "本周剧集「追更指南」",
    sub: "今晚更新合集",
    desc: "集中梳理各平台热播剧的更新时间表与剧情看点，把「今晚更几集、明天更什么」一次性讲清楚。",
    tag: "剧集路透",
    date: "每日推荐 · 本周",
    read: "52 万围观",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20cozy%20tv%20screen%20with%20film%20clapperboard%20and%20popcorn%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20cinematic%20composition&width=800&height=600&seq=chigua-pick-02&orientation=landscape",
  },
  {
    id: 3,
    title: "本周「话题热词」风向标",
    sub: "网友都在聊",
    desc: "拆解一周内被反复提及的热词与梗，看看评论区的审美风向、情绪走向都悄悄发生了哪些变化。",
    tag: "网友热议",
    date: "每日推荐 · 本周",
    read: "47 万围观",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20large%20chat%20bubble%20with%20hashtags%20and%20floating%20comment%20icons%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20cinematic%20composition&width=800&height=600&seq=chigua-pick-03&orientation=landscape",
  },
];

export type LatestItem = {
  id: number;
  category: string;
  title: string;
  meta: string;
  img: string;
};

export const latestList: LatestItem[] = [
  {
    id: 1,
    category: "榜单盘点",
    title: "本周综艺热度榜：口碑黑马仍在冲顶",
    meta: "昨日 22:00 更新",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20golden%20ranking%20podium%20with%20medals%20and%20number%20flags%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20composition&width=640&height=640&seq=chigua-latest-01&orientation=squarish",
  },
  {
    id: 2,
    category: "红毯现场",
    title: "年度盛典看秀造型图鉴新鲜出炉",
    meta: "今日 09:40 更新",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20fashion%20runway%20with%20glamorous%20outfit%20silhouettes%20and%20camera%20flashes%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20composition&width=640&height=640&seq=chigua-latest-02&orientation=squarish",
  },
  {
    id: 3,
    category: "综艺速递",
    title: "《周末开麦》收官舞台全程回顾",
    meta: "今日 08:15 更新",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20microphone%20with%20music%20notes%20bursting%20outward%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20composition&width=640&height=640&seq=chigua-latest-03&orientation=squarish",
  },
  {
    id: 4,
    category: "网友热议",
    title: "「回忆杀」为何每年都能霸榜",
    meta: "今日 07:30 更新",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20cassette%20tape%20and%20polaroid%20photos%20of%20past%20moments%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20composition&width=640&height=640&seq=chigua-latest-04&orientation=squarish",
  },
  {
    id: 5,
    category: "剧集路透",
    title: "《长风引》高能片段合集，弹幕名场面整理",
    meta: "今日 06:50 更新",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20an%20ancient%20chinese%20lantern%20and%20scroll%20with%20floating%20drama%20frames%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20composition&width=640&height=640&seq=chigua-latest-05&orientation=squarish",
  },
  {
    id: 6,
    category: "新歌首发",
    title: "本周新歌首播合集，风格转型试听现场",
    meta: "今日 06:10 更新",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20vinyl%20record%20player%20with%20sound%20waves%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20composition&width=640&height=640&seq=chigua-latest-06&orientation=squarish",
  },
  {
    id: 7,
    category: "实时更新",
    title: "盛典活动排期表：接下来一个月别错过",
    meta: "今日 05:30 更新",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20calendar%20with%20stars%20and%20confetti%20around%20event%20dates%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20composition&width=640&height=640&seq=chigua-latest-07&orientation=squarish",
  },
  {
    id: 8,
    category: "榜单盘点",
    title: "年度剧集金榜入围名单抢先看",
    meta: "今日 04:45 更新",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20golden%20trophy%20with%20a%20film%20clapperboard%20and%20stars%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20composition&width=640&height=640&seq=chigua-latest-08&orientation=squarish",
  },
];

export type TopicGroup = {
  group: string;
  icon: string;
  items: { label: string; count: number }[];
};

export const topicWall: TopicGroup[] = [
  {
    group: "正在追",
    icon: "ri-flashlight-fill",
    items: [
      { label: "跨年盛典", count: 321 },
      { label: "长风引加更", count: 278 },
      { label: "周末开麦", count: 245 },
      { label: "回忆杀歌单", count: 198 },
    ],
  },
  {
    group: "综艺现场",
    icon: "ri-mic-fill",
    items: [
      { label: "观察类真人秀", count: 187 },
      { label: "舞台竞演", count: 174 },
      { label: "慢生活旅行", count: 132 },
      { label: "脱口秀现场", count: 96 },
    ],
  },
  {
    group: "剧集片单",
    icon: "ri-film-fill",
    items: [
      { label: "古装权谋", count: 156 },
      { label: "都市情感", count: 149 },
      { label: "悬疑烧脑", count: 128 },
      { label: "治愈系短剧", count: 102 },
    ],
  },
  {
    group: "实时热词",
    icon: "ri-fire-fill",
    items: [
      { label: "二搭愿望", count: 264 },
      { label: "红毯造型", count: 233 },
      { label: "涨粉黑马", count: 176 },
      { label: "风格转型", count: 119 },
    ],
  },
];

export type CollectionItem = {
  id: number;
  title: string;
  sub: string;
  desc: string;
  count: number;
  tags: string[];
  img: string;
};

export const collections: CollectionItem[] = [
  {
    id: 1,
    title: "年度综艺高光全记录",
    sub: "一整年的名场面都在这里",
    desc: "从舞台首秀到收官夜，把年度讨论度最高的综艺瞬间按时间线归档，想回看随时点进合集。",
    count: 42,
    tags: ["舞台高光", "爆梗时刻", "名场面"],
    img: "https://readdy.ai/api/search-image?query=wide%20flat%20editorial%20vector%20illustration%20of%20a%20grand%20stage%20curtain%20with%20glowing%20spotlights%20and%20confetti%20shower%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20wide%20cinematic%20composition&width=1280&height=560&seq=chigua-col-01&orientation=landscape",
  },
  {
    id: 2,
    title: "年度剧集追更日历",
    sub: "播出时间表一次收好",
    desc: "把各平台在播、待播热剧的更新时间与定档节奏整理成可勾选日历，追更不再错过任何一集。",
    count: 36,
    tags: ["定档日历", "加更提醒", "原著对照"],
    img: "https://readdy.ai/api/search-image?query=wide%20flat%20editorial%20vector%20illustration%20of%20a%20large%20calendar%20wall%20with%20film%20clapperboards%20and%20play%20buttons%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20wide%20cinematic%20composition&width=1280&height=560&seq=chigua-col-02&orientation=landscape",
  },
  {
    id: 3,
    title: "网友热词风向档案",
    sub: "这周大家在聊什么",
    desc: "按周归档网友讨论度最高的热词与梗，附上热度曲线与前后对照，趋势变化一目了然。",
    count: 28,
    tags: ["热词解读", "趋势曲线", "网友视角"],
    img: "https://readdy.ai/api/search-image?query=wide%20flat%20editorial%20vector%20illustration%20of%20an%20upward%20trend%20chart%20made%20of%20rising%20speech%20bubbles%20and%20hashtag%20blocks%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20wide%20cinematic%20composition&width=1280&height=560&seq=chigua-col-03&orientation=landscape",
  },
];

export const heroStats = [
  { label: "今日更新", value: "186", unit: "篇" },
  { label: "实时热词", value: "32", unit: "个" },
  { label: "追更专题", value: "12", unit: "合集" },
  { label: "每日推荐", value: "18", unit: "条" },
];

export const footerQuick = [
  { title: "内容分区", links: ["今日更新", "每日推荐", "实时热榜", "最新发布", "新鲜出炉"] },
  { title: "追更服务", links: ["话题墙", "专题合集", "热词档案", "追更日历", "榜单盘点"] },
  { title: "关于我们", links: ["站点介绍", "更新说明", "内容收录", "合作联系", "意见反馈"] },
];